import { useEffect, useState } from 'react'

import ListLoader from '@/components/util/ListLoader'

const useRenderLimit = <T extends any[]>(list?: T, renderLimitInit = 50, step = 20) => {
  const [renderLimit, setRenderLimit] = useState(renderLimitInit)

  const increaseRenderLimit = () => setRenderLimit(renderLimit + step)

  useEffect(() => {
    setRenderLimit(renderLimitInit)
  }, [list?.length, renderLimitInit])

  return {
    visibleList: list?.slice(0, renderLimit) as T,
    ListLoaderComponent: () => (
      <ListLoader
        conditionSelector={() => (list?.length || 0) > renderLimit}
        action={increaseRenderLimit}
      />
    ),
  }
}

export default useRenderLimit
